// Module
var code = `<section class="deeplink-error" ng-class="{'deeplink-error--desktop': !\$ctrl.state.isMobile}">

    <div class="deeplink-mobile__hero" ng-if="\$ctrl.state.isMobile">

        <img
            class="deeplink-mobile__hero-background"
            ng-src="{{ \$ctrl.data.mobile.heroBackground }}"
            alt=""
            aria-hidden="true">

        <img
            class="deeplink-mobile__hero-logo"
            ng-src="{{ \$ctrl.data.mobile.heroLogo }}"
            alt="Toke">

        <img
            class="deeplink-mobile__hero-coin"
            ng-src="{{ \$ctrl.data.mobile.heroCoin }}"
            alt=""
            aria-hidden="true">

        <div class="deeplink-mobile__badge">
            {{ \$ctrl.data.mobile.badgeLabel }}
        </div>

    </div>

    <div class="deeplink-error__card">

        <div class="deeplink-error__icon-wrap" aria-hidden="true">
            <svg class="deeplink-error__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/>
                <line x1="12" y1="8" x2="12" y2="12.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <circle cx="12" cy="16" r="1" fill="currentColor"/>
            </svg>
        </div>

        <h1 class="deeplink-error__title">{{ \$ctrl.data.error.title }}</h1>

        <p class="deeplink-error__body">{{ \$ctrl.data.error.body }}</p>

    </div>

</section>
`;
// Exports
export default code;